var SelectRowCell = require('psa-backgrid/SelectRowCell');

var SelectPageCell = SelectRowCell.SelectAllHeaderCell.extend({
  events: {
    'change input[type=checkbox]': 'onToggle'
  },

  onToggle: function() {
    var checked = this.$('input[type=checkbox]').prop('checked');

    var pageModels = this.collection.models;

    pageModels.forEach(model => {
      model.trigger('backgrid:select', model, checked);
    });
  }
});

module.exports = SelectPageCell;
